<p>
  {{ 'imageLibrary.download' | cxTranslate }}
</p>

@for (brand of brands; track brand) {
  <div class="mt-5 mb-5">
    <img src="public/images/{{ brand }}-logo.png" />
    <button type="button" class="btn btn-primary" (click)="downloadZip(brand + '-image-library')">
      {{ 'imageLibrary.downloadButton' | cxTranslate }}
    </button>
  </div>
}
